import React, { createContext, useContext, useEffect, useState } from 'react';
import usePortfolioData from '../services/portfolio/usePortfolioData';
import { TopProject } from '../types/globalTypes';
import { getNewProjectsByDate } from '../utils/getNewProjectsByDate';

interface PortfolioContextType {
  newProjects: TopProject[];
}

const PortfolioContext = createContext<PortfolioContextType | undefined>(undefined);

export const PortfolioProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { portfolioData } = usePortfolioData();
  const [newProjects, setNewProjects] = useState<TopProject[]>([]);

  useEffect(() => {
    if (portfolioData?.projects) {
      const filteredProjects = getNewProjectsByDate(portfolioData.projects);
      setNewProjects(filteredProjects);
    }
  }, [portfolioData]);

  return (
    <PortfolioContext.Provider value={{ newProjects }}>
      {children}
    </PortfolioContext.Provider>
  );
};

export const usePortfolioContext = () => {
  const context = useContext(PortfolioContext);
  if (context === undefined) {
    throw new Error('usePortfolio must be used within a PortfolioProvider');
  }
  return context;
}; 